import React from 'react';
import {Link} from 'react-router';

const CookieNotice = React.forwardRef(({onAccept}, ref) => {
    return (
        <div ref={ref}
             className="fixed bottom-0 w-full bg-primary text-text-white text-sm p-4 flex flex-col sm:flex-row justify-between items-center z-40 shadow-md transition-all duration-300">
            <p className="mb-2 sm:mb-0">
                We use essential cookies to run our site and measure ad performance.
                No tracking or marketing cookies are used. Read our{' '}
                <Link to="/privacy-policy" className="underline hover:text-secondary">
                    Privacy Policy
                </Link>{' '}
                and{' '}
                <Link to="/terms-of-use" className="underline hover:text-secondary">
                    Terms of Service
                </Link>.
            </p>
            <button
                onClick={onAccept}
                className="bg-white text-primary px-4 py-1 rounded hover:bg-gray-100 transition"
            >
                Got it
            </button>
        </div>
    );
});

export default CookieNotice;
